import type { FieldError } from "react-hook-form"
import React from "react"
import WrapWithErrorStyles from "./wrap-with-error.module.css"
import classNames from "classnames"

type WrapWithErrorProps = {
    error?: FieldError
    info?: { message: string }
    noSpace?: boolean
    hideError?: boolean
    id: string
    children: React.ReactNode
}

const WrapWithError = ({ error, info, noSpace, hideError, id, children }: WrapWithErrorProps) => {
    return (
        <>
            {children}
            <div
                className={classNames(WrapWithErrorStyles.block, {
                    [WrapWithErrorStyles.error]: error,
                    [WrapWithErrorStyles.info]: info,
                    [WrapWithErrorStyles.noSpace]: noSpace,
                    [WrapWithErrorStyles.hideError]: hideError,
                })}
            >
                <i className="lavita-icon"></i>
                <span aria-live="polite" id={"err-" + id}>{error?.message || info?.message}</span>
            </div>
        </>
    )
}

export default WrapWithError
